module.exports = [{
      plugin: require('../../node_modules/.pnpm/gatsby-plugin-manifest@3.15.0_gatsby@3.15.0_@types+node@20.12.8_babel-eslint@10.1.0_eslint@7._emvwdpwtdd2fh7sbrr7zd5xejq/node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"web4jobs","short_name":"fCC","start_url":"/","theme_color":"#0a0a23","background_color":"#fff","display":"minimal-ui","icon":"src/assets/images/logo.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"ec9e234cd789c5a1faf4c00ffc628d00"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
